<div class="grid">
    <div class="column1">
        <ul class="list-results">
            <h2>Books</h2>
            <li>
                <div *ngIf="!bookService.keepFocus">
                    <button (click)="addBook()">+ Add New Book</button>
                </div>
            </li>

            <li *ngFor="let book of allBooks | async">
                <div *ngIf="book == bookService.selectedBook; else notSelected">
                    <span class="selected" (click)="selectBook(book)">{{book.title}}</span>
                </div>
                <ng-template #notSelected>
                    <div *ngIf="!bookService.keepFocus">
                        <button (click)="selectBook(book)">{{book.title}}</button>
                    </div>
                </ng-template>
            </li>
        </ul>
    </div>

    <div class="seperator-line"></div>

    <div class="column2">
        <ng-container *ngIf="bookService.selectedBook">
            <app-selected-book [selectedBook]="bookService.selectedBook"> </app-selected-book>
        </ng-container>
        <ng-container *ngIf="bookService.addingNewBook">
            <app-new-book></app-new-book>
        </ng-container>
    </div>
</div>